import { removeUserAsAdmin } from './authService';
import { callFunction, getCallableErrorMessage } from './functionsService';

export async function listUnassignedCoins({ page = 1, pageSize } = {}) {
  return callFunction('listUnassignedCoins', { page, pageSize });
}

export async function sellCoin(coinId) {
  return callFunction('sellCoin', { coinId });
}

function shouldFallbackToClientRemoval(error) {
  const code = error?.code || '';
  const message = (error?.message || '').toLowerCase();

  return (
    code === 'functions/not-found' ||
    code === 'functions/unavailable' ||
    code === 'functions/internal' ||
    code === 'functions/deadline-exceeded' ||
    message.includes('cors') ||
    message.includes('failed to fetch') ||
    message.includes('network')
  );
}

export async function removeUser(userId) {
  try {
    const result = await callFunction('removeUser', { userId });
    return {
      ...result,
      authDeleted: true,
    };
  } catch (error) {
    if (!shouldFallbackToClientRemoval(error)) {
      throw new Error(getCallableErrorMessage(error));
    }

    const result = await removeUserAsAdmin(userId);
    return {
      ...result,
      warning:
        'User profile removed. Deploy the removeUser cloud function to also delete the Firebase auth account.',
    };
  }
}
